const CustomEventNames = {
	// UPDATE_REDUX_WITH_WINDOW_VARIABLES: "UPDATE_REDUX_WITH_WINDOW_VARIABLES",
	LOG_IN_WITH_ID_TOKEN: "LOG_IN_WITH_ID_TOKEN",
	PASS_RC_PACKAGES: "PASS_RC_PACKAGES",
	REDIRECT_TO_PAGE: "REDIRECT_TO_PAGE",
	STOP_LOADING_ANIMATION: "STOP_LOADING_ANIMATION",
};

export default CustomEventNames;
